import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { FileText, Upload, X, Loader2 } from "lucide-react";

const TIPI = [["cga", "CGA"], ["dip", "DIP"], ["dip_agg", "DIP Aggiuntivo"]];

export function ProdottoDocumenti({ code, documenti, onChange }) {
  const [busy, setBusy] = useState("");

  const upload = async (tipo, file) => {
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".pdf")) { toast.error("Carica un file PDF"); return; }
    setBusy(tipo);
    try {
      const fd = new FormData();
      fd.append("file", file); fd.append("modulo", "catalogo"); fd.append("ref_id", `${code || "nuovo"}:${tipo}`);
      const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange({ ...documenti, [tipo]: { file_id: data.id, filename: data.original_filename, caricato_at: data.created_at } });
      toast.success("Documento caricato: ricorda di salvare il prodotto");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(""); }
  };

  const rimuovi = (tipo) => { const n = { ...documenti }; delete n[tipo]; onChange(n); };

  return (
    <div className="space-y-2" data-testid="prod-documenti">
      <Label>Documenti precontrattuali (allegati all'invio al cliente)</Label>
      <div className="rounded-lg border border-slate-200 divide-y divide-slate-100">
        {TIPI.map(([tipo, label]) => {
          const doc = documenti?.[tipo];
          return (
            <div key={tipo} className="flex items-center justify-between gap-2 px-3 py-2" data-testid={`prod-doc-${tipo}`}>
              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-700">{label}</p>
                {doc ? (
                  <a href={`${process.env.REACT_APP_BACKEND_URL}/api/files/${doc.file_id}/download`} target="_blank" rel="noopener noreferrer" className="text-xs text-indigo-600 hover:underline inline-flex items-center gap-1 truncate max-w-[260px]">
                    <FileText className="h-3 w-3 shrink-0" />{doc.filename}
                  </a>
                ) : <p className="text-xs text-slate-400">Non caricato</p>}
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <label className="inline-flex">
                  <input type="file" accept="application/pdf" className="hidden" onChange={(e) => { upload(tipo, e.target.files?.[0]); e.target.value = ""; }} data-testid={`prod-doc-input-${tipo}`} />
                  <span className="inline-flex items-center text-xs px-2.5 py-1.5 rounded-md border border-slate-200 hover:bg-slate-50 cursor-pointer transition-colors">
                    {busy === tipo ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Upload className="h-3.5 w-3.5 mr-1" />}{doc ? "Sostituisci" : "Carica"}
                  </span>
                </label>
                {doc && <Button type="button" variant="ghost" size="icon" className="h-7 w-7 text-red-500" onClick={() => rimuovi(tipo)} data-testid={`prod-doc-remove-${tipo}`}><X className="h-3.5 w-3.5" /></Button>}
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-slate-400">Se un documento non è caricato qui, viene preso dal Portale Partner (quando il Portale ne permetterà il download).</p>
    </div>
  );
}
